// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".closeMenu{width:44px!important}.closeMenu,.openMenu{-webkit-transition:all .3s;transition:all .3s}.openMenu{width:200px!important}.appsMenuBox{background:#3c465c!important}", ""]);
// Exports
module.exports = exports;
